import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { InputText } from "../../components/inputs";

const FormularioContrasenha = ({ data, onClickProcesarContrasenha, mensaje }) => {

    const [contrasenaTemporal, setContrasenaTemporal] = useState('');
    const [validated, setValidated] = useState(false);

    const onClickAceptar = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const data = {
                contrasenaTemporal: contrasenaTemporal
            }
            onClickProcesarContrasenha(data);
        }
        setValidated(true);
        event.preventDefault();
    }

    const onChangeContrasenha = (e) => setContrasenaTemporal(e.target.value);

    return (
        <>
            <Form noValidate validated={validated} onSubmit={onClickAceptar}>
                <span>Usuario: {data.nombre} {data.primerApellido} {data.segundoApellido}</span>
                <InputText id='txt-contrasenha' label='Contraseña:' type='password' placeholder='Ingrese la contraseña' value={contrasenaTemporal}
                    text='Contraseña temporal.' onChange={onChangeContrasenha} mensajeValidacion="La contraseña es requerida" className="" />
                {mensaje !== "" ? <p className="text-info text-center">{mensaje}</p> : ""}
                <div className='text-right'>
                    <Button
                        className="mr-1 mb-2 card-button"
                        variant="primary"
                        type="submit"
                        size="sm">
                        <FontAwesomeIcon icon={faCheck} className="mr-2" />
                        Actualizar
                    </Button>
                </div>
            </Form>
        </>
    )
}

export default FormularioContrasenha;